import { getUserPersistedInfo } from "./utils";

import generatePageId from "@gerenciatd/next13.utils.page.generate-page-id";
import getReadyGA from "@gerenciatd/next13.utils.common.get-ga-cookie";
import getSessId from "@gerenciatd/next13.utils.page.get-sess-id";
import getTabId from "@gerenciatd/next13.utils.page.get-tab-id";
import getContextSeoInfo from "@gerenciatd/next13.utils.page.get-context-seo-info";
import gaEvents from "../ga-events";


const removeNumberGroupsFromUrl = (urlString) => {
  let res = urlString;
  try {
    const currentUrl = new URL(urlString);
    const { host, protocol, port } = currentUrl;
    let { pathname } = currentUrl;
    pathname = pathname.split('/').map((tokenUrl) => {
      let isNotNumber = isNaN(tokenUrl)
      if (isNotNumber) {
        return tokenUrl;
      }
      return '';
    })
    pathname = pathname.filter(item => !!item);
    pathname.unshift(host);
    pathname.unshift(`${protocol}/`)
    
    pathname = pathname.join('/');
    res = pathname;
  } catch(err){
    console.error(err)
  }
  return res ;
}

export const createContext = async ({
  context,
  setUserPqInfo,
  setUserLgInfo,
  setContextData,
  ad_storage,
  analytics_storage,
  ad_user_data,
  ad_personalization,
  isReactApp,
}) => {
  // 1) Formamos el objeto context inicial
  const ssrContext = context;
  let initialContextData = {};

  // 1.1) Traemos ts de local storage, pero si han pasado mas de 6 meses se borra para recargar la info (se encarga getUserPersistedInfo)
  const persistedInfo = { ...getUserPersistedInfo() };
  let userName = "";
  let userType = "";
  let userIdPartyHash = "";
  let userCUCFijoHash = "";
  let userCUCMovilHash = "";
  let userCUCPrepagoHash = "";
  if (persistedInfo) {
    userName = persistedInfo.userName || "";
    userType = persistedInfo.userType || "";
    userIdPartyHash = persistedInfo.userIdPartyHash || "";
    userCUCFijoHash = persistedInfo.userCUCFijoHash || "";
    userCUCMovilHash = persistedInfo.userCUCMovilHash || "";
    userCUCPrepagoHash = persistedInfo.userCUCPrepagoHash || "";
  }

  let contextURL = window.location.href;
  if (isReactApp) {
    contextURL = removeNumberGroupsFromUrl(contextURL)
  }

  try {
    const pageId = generatePageId();
    window.pageId = pageId;

    // 1.2) Creamos el objeto context con info inicial y la info recogida anteriormente
    initialContextData = {
      ...ssrContext,
      numLocationChanges: 0,
      tabId: getTabId(),
      pageWebCode: null,
      pageName: null,
      pageWebName: null,
      pageProductCode: null,
      pageProductName: null,
      clientIDs: {
        pageId,
        ga: getReadyGA(),
        sessId: getSessId(),
      },
      pageSegment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`,
      contextURL,
      subseg: false,
      userPriority: false,
      version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || "unknown",
      ...getContextSeoInfo(),
      userName,
      userType,
      userIdPartyHash,
      userCUCFijoHash,
      userCUCMovilHash,
      userCUCPrepagoHash,
    };

    // 1.3) Antes de acabar limpiamos las variables dentro de initialContextData (esta info ahora la tendriamos en main y no hace falta en context)
    if (initialContextData) {
      delete initialContextData.geo;
    }
    setContextData(initialContextData);
  } catch (error) {
    console.error(error);
  }

  // 2) Extraemos la info de usuario
  let userPq = {};
  let userFlags = [];
  let userLg = null;

  // 2.1) userPq
  if (persistedInfo.userPq) {
    userPq = persistedInfo.userPq;
    userFlags = persistedInfo.userFlags || [];
  }
  setUserPqInfo({
    userPq,
    userFlags,
  });

  // 2.2) userLg
  if (persistedInfo.userLg) {
    userLg = persistedInfo.userLg;
    setUserLgInfo({ userLg });
  }

  // 3) Enviamos a GA si el cliente ha aceptado cookies y tambien info de este
  try {
    gaEvents({
      context: initialContextData,
      setContextData,
      ad_storage,
      analytics_storage,
      ad_user_data,
      ad_personalization 
    });
  } catch (error) {
    console.error(error);
  }
};

export default createContext;